import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Award, Search, ChevronDown } from 'lucide-react';

// ⭐ IMPORT YOUR LOGO
import logo from '../images/logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    { name: 'HOME', path: '/', hasDropdown: false },
    { name: 'COMPANY', path: '/company', hasDropdown: false },
    { name: 'PROJECTS', path: '/projects', hasDropdown: false },
    { name: 'SERVICES', path: '/services', hasDropdown: false },
    { name: 'ISOSTANDARD', path: '/IsoStandard', hasDropdown: false },
    
   
    
    

    {
      name: 'PRODUCTS',
      path: '/products',
      hasDropdown: true,
      dropdownItems: [
        { name: 'Batteries', path: '/products/batteries' }
      ]
    },

    { name: 'YOUR TEAM', path: '/news', hasDropdown: false },
    { name: 'CONTACT', path: '/contact', hasDropdown: false }
  ];

  return (
    <>
      {/* Info Bar */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">

            {/* ⭐ LOGO SECTION */}
            <Link to="/" className="flex items-center gap-2">
              <img 
                src={logo} 
                alt="ARANVIC Logo" 
                className="w-12 h-12 object-contain"
              />
              <span className="text-3xl font-bold text-gray-800">
                ARANVIC
              </span>
            </Link>

            {/* Contact Info */}
            <div className="hidden lg:flex items-center gap-8">
              <div className="text-center">
                <div className="text-xs text-gray-500 mb-1">Call Us</div>
                <div className="flex items-center gap-2 font-semibold text-gray-800">
                  <Phone size={18} className="text-yellow-500" />
                  (+91) 91139 97209 
                </div>
              </div>

              <div className="text-center">
                <div className="text-xs text-gray-500 mb-1">Email Us</div>
                <div className="flex items-center gap-2 font-semibold text-gray-800">
                  <Mail size={18} className="text-yellow-500" />
                  aranvicsystems.com
                </div>
              </div>

              <div className="text-center">
                <div className="text-xs text-gray-500 mb-1">Global Certificate</div>
                <div className="flex items-center gap-2 font-semibold text-gray-800">
                  <Award size={18} className="text-yellow-500" />
                  ISO 9001:2015
                </div>
              </div>

              <Link
                to="/contact"
                className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 font-semibold transition-colors"
              >
                Get A Quote
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className={`bg-gray-800 sticky top-0 z-50 transition-all ${isScrolled ? 'shadow-lg' : ''}`}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            
            {/* MENU ITEMS */}
            <ul className="flex items-center gap-1">
              {menuItems.map((item) => (
                <li
                  key={item.name}
                  className="relative"
                  onMouseEnter={() => item.hasDropdown && setActiveDropdown(item.name)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <Link
                    to={item.path}
                    className={`flex items-center gap-1 px-5 py-4 text-sm font-semibold transition-colors ${
                      isActive(item.path)
                        ? 'text-yellow-500 bg-gray-700'
                        : 'text-white hover:text-yellow-500'
                    }`}
                  >
                    {item.name}
                    {item.hasDropdown && <ChevronDown size={16} />}
                  </Link>

                  {/* ⭐ DROPDOWN MENU */}
                  {item.hasDropdown && activeDropdown === item.name && (
                    <ul className="absolute left-0 top-full bg-gray-800 shadow-lg w-48 py-2 z-50">
                      {item.dropdownItems?.map((drop) => (
                        <li key={drop.name}>
                          <Link
                            to={drop.path}
                            className="block px-4 py-2 text-sm text-white hover:bg-gray-700 hover:text-yellow-400"
                          >
                            {drop.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>

            <button className="text-white hover:text-yellow-500 transition-colors p-4">
              <Search size={20} />
            </button>

          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
